import { apiConfig } from '@/services/api-config';

export default async function (tokenKey: string, stEmail: string, document: string) {
  return apiConfig
    .put(`api/DocumentPaliative/document_producer-update?email=${stEmail}&document=${document}&tokenKey=${tokenKey}`)
    .then((response) => response.data)
    .catch(() => []);
}
